import React, { useState } from 'react';

export default function CopyCard({ text }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className="group relative flex flex-col items-start text-left w-full p-6 bg-white border border-hairline hover:border-navy transition-colors duration-200"
      aria-label="Copy question to clipboard"
    >
      <span className="font-body italic text-lg leading-relaxed text-navy mb-8">
        {text}
      </span>
      <span className="mt-auto font-display text-xs font-medium uppercase tracking-wider text-navy/60 group-hover:text-navy transition-colors">
        {copied ? 'Copied — paste it into the chat' : 'Click to copy'}
      </span>
    </button>
  );
}